import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { DataExportComponent } from './components/data-export/data-export.component';
import { DataExportSuccessComponent } from './components/data-export-success/data-export-success.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ControllerInventorySuccessComponent } from './components/controller-inventory-success/controller-inventory-success.component';
import { DeviceConfigurationSuccessComponent } from './components/device-configuration-success/device-configuration-success.component';
import { DeleteAccountRequestComponent } from './components/delete-account-request/delete-account-request.component';
import { DeleteRequestSuccessComponent } from './components/delete-request-success/delete-request-success.component';
import { DeleteAccountComponent } from './components/delete-account/delete-account.component';
import { DeleteAccountSucessComponent } from './components/delete-account-sucess/delete-account-sucess.component';
import { InstallerModule } from './modules/installer/installer.module';
import { loginGuard } from './guards/login.guard';
import { AuthGuard } from './guards/auth.guard';
import { AdminModule } from './modules/admin/admin.module';
import { TwoFactorAuthenticateComponent } from './components/two-factor-authenticate/two-factor-authenticate.component';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { RestrictedAccessComponent } from './components/restricted-access/restricted-access.component';
import { AccountCreateSuccessComponent } from './components/account-create-success/account-create-success.component';
import { UserExistComponent } from './components/user-exist/user-exist.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/login' },
  {path:'register',component:CreateAccountComponent},
  {path:'restricted',component:RestrictedAccessComponent},
  {path:'account/success',component:AccountCreateSuccessComponent},
  {path:"account/exist",component:UserExistComponent},
  {
    path: 'authenticate',
    component: TwoFactorAuthenticateComponent,
    canActivate: [loginGuard],
  },
  { path: 'login', component: LoginComponent, canActivate: [loginGuard] },
  {
    path: 'dataexport',
    component: DataExportComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'dataexport/success',
    component: DataExportSuccessComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'account/delete/request/success',
    component: DeleteRequestSuccessComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'account/delete/success',
    component: DeleteAccountSucessComponent,
    canActivate: [loginGuard],
  },
  { path: 'error', component: ErrorPageComponent, canActivate: [loginGuard] },
  {
    path: 'controller/add/success',
    component: ControllerInventorySuccessComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'device/configuration/add/success',
    component: DeviceConfigurationSuccessComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'account/delete/request',
    component: DeleteAccountRequestComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'account/delete',
    component: DeleteAccountComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'installer',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/installer/installer.module').then(
        (m) => InstallerModule
      ),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/admin/admin.module').then((m) => AdminModule),
  },
  { path: '**', component: NotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
